import { Modal } from 'antd';
import PayList from 'pages/Payment/PAYList';
import React from 'react';
import { PaymentSelectedType } from './PaymentSelect';


export type PaymentSearchModalProps =  {
  visible: boolean;
  onCancel: () => void;
  setPayment: (
    Payment: PaymentSelectedType
  ) => void;
  ctref?: string;
};

const PaymentSearchModal = ({
  onCancel,
  visible,
  setPayment,
  ctref
}: PaymentSearchModalProps) => {
  return (
    <Modal visible={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <PayList
        onSelect={setPayment}
        hideCol
        hideExtraAction
        propref={ctref}
      />
    </Modal>
  );
};

export default PaymentSearchModal;
